import { Attachment } from '@/types/types';
import { QueryKey } from '@/configs/queryKeys';
import { MeshStandardMaterialParameters } from 'three';
import EntityApi, { BaseEntity } from './EntityApi';

export enum MapType {
	BASE = 'BASE',
	ROUGHNESS = 'ROUGHNESS',
	NORMAL = 'NORMAL',
	HEIGHT = 'HEIGHT',
	METALLNESS = 'METALLNESS',
	AO = 'AO',
	LIGHT = 'LIGHT',
}

export enum AssetType {
	MATERIAL = 'MATERIAL',
	MODEL = 'MODEL',
}

export type AssetOptions = Pick<
	MeshStandardMaterialParameters,
	'metalness' | 'roughness'
>;

export interface Asset extends BaseEntity {
	name: string;
	type: AssetType;
	model: Attachment | null;
	maps: Record<MapType, Attachment | null>;
	options: AssetOptions;
}

class AssetApi extends EntityApi<Asset> {
	constructor() {
		super(QueryKey.assets);
	}
}

export default new AssetApi();
